import { createContext } from 'react';
import { PaymentUser } from 'src/models/payment-user';

export interface PaymentUserContextType {
  addPaymentUser: (data: PaymentUser) => void;
  paymentUser: PaymentUser | undefined;
}

export const PaymentUserContext = createContext<PaymentUserContextType>(
  {} as PaymentUserContextType
);
